import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class PrimeNgMessageService {
  messageService = inject(MessageService);
  translocoService = inject(TranslocoService);

  async showError(messageKey: string) {
    const title = await this.translocoService.translate('global.error.dialog.title');
    const message = await this.translocoService.translate(messageKey);
    this.messageService.add({ severity: 'error', summary: title, detail: message, life: 5000 });
  }

  async showSuccess(messageKey: string) {
    const title = await this.translocoService.translate('global.success.dialog.title');
    const message = await this.translocoService.translate(messageKey);
    this.messageService.add({ severity: 'success', summary: title, detail: message, life: 5000 });
  }
}
